<p data-test-id="static-taetigkeit">{{ staticTaetigkeitLabel() }}</p>
<schir-int-client-notiz-in-aufgabe-editor [aufgabenTyp]="aufgabenTyp()" data-test-id="aufgabe-notiz" />
